export const extras = [
  {
    id: null,
    name: 'Extras',
    minimumSelections: null,
    maximumSelections: null,
    optionsPerGuest: true,
    isExtras: true,
    supportsSelections: false,
    isRequired: false,
    options: [
      {
        id: null,
        name: 'Arrival Drink',
        description: null,
        image: {
          externalKey: '0f8fe28e1793c51e09a50f2f59787953',
          url: 'https://products-stage-onejourney-private.s3.amazonaws.com/0f8fe28e1793c51e09a50f2f59787953.jpg',
        },
        price: {
          amount: 150,
          currencyCode: 'gbp',
        },
        extra: {
          id: 31,
        },
      },
      {
        id: null,
        name: 'Bath Robe',
        description: null,
        image: null,
        price: {
          amount: 2000,
          currencyCode: 'gbp',
        },
        extra: {
          id: 32,
        },
      },
      {
        id: null,
        name: 'Fruit Platter',
        description: null,
        image: null,
        price: {
          amount: 750,
          currencyCode: 'gbp',
        },
        extra: {
          id: 33,
        },
      },
      {
        id: null,
        name: 'Glass Wine',
        description: null,
        image: null,
        price: {
          amount: 350,
          currencyCode: 'gbp',
        },
        extra: {
          id: 34,
        },
      },
      {
        id: null,
        name: 'Newspaper',
        description: null,
        image: null,
        price: {
          amount: 0,
          currencyCode: 'gbp',
        },
        extra: {
          id: 35,
        },
      },
      {
        id: null,
        name: 'Towel',
        description: null,
        image: null,
        price: {
          amount: 999,
          currencyCode: 'gbp',
        },
        extra: {
          id: 36,
        },
      },
    ],
  },
];
